import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, UntypedFormGroup } from '@angular/forms';
import { IpPublicService } from '../../../../services/ip-public.service';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { forkJoin, map } from 'rxjs';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ElementoNivelPermisoService } from '../../services/elemento.nivel.permiso.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { AplicacionesService } from '../../services/aplicaciones.service';
import { RiesgosService } from 'src/app/modulos/elementos-plan/services/riesgos.service';
import { IndicadoresService } from 'src/app/modulos/elementos-plan/services/indicadores.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { AmbienteService } from 'src/app/modulos/catalogos-admin/services/ambiente.service';
import { Rol } from '../../models/rol';
import { Ambiente } from 'src/app/modulos/catalogos-proces/models/ambiente';
import * as globalAccions from "./../../../../redux/global/global.actions"


@Component({
  selector: 'app-observador',
  templateUrl: './observador.component.html',
  styleUrls: ['./observador.component.css']
})
export class ObservadorComponent implements OnInit, AfterContentChecked {
  breadCrumbItems = [
    { label: 'Administración Sistema' },
    { label: 'Catálogos' },
    { label: 'Permisos niveles elementos', active: true },
  ];

  public formPermiso!: UntypedFormGroup;
  public formSubmitted = false;
  public ipAddress!: string;
  public idSprUsuario!: number;
  public idSprPlanAnio: number = 0;
  public idSprAmbiente!: number;
  private currentUser!: any;
  public idSprElementoNivelPermiso: number = 0;
  public idSprElemento: number = 0;
  public idSprAmbienteSelected: number = 0;
  public idSprNivelSelected: number = 0;
  public idSprIndicadorSelected: number = 0;
  public idSprRiesgoSelected: number = 0;
  public idSprNivelAmbienteParaItem: number = 0;
  public idRolObservador: number = 0;
  public idRolLinderMetodologico: number = 0;

  public selectItems: any[] = [];
  public elementosIdicadores: any[] = [];
  public dataElementosNivelesPermisos: any[] = [];
  public dataAmbientesNiveles: any[] = [];
  public dataNiveles: any[] = [];
  public dataAmbientes: any[] = [];
  public dataAplicaciones: any[] = [];
  public dataIndicadores: any[] = [];
  public dataRiesgos: any[] = [];
  public nameModalBuscar: string = 'modalNewEdit1234';
  public nameApp = 'OBSERVAR ELEMENTOS';
  public valueElemento: any;
  public nombreElemento: any;
  currentUserRedux: UsuarioRedux = null;
  readonly constant = ConstantsCatalogosIdService;
  ///////////////////////////////////////////////
  public formSelectRolAmbiente!: FormGroup;
  selectedOption: any;
  buffer: string;
  dataUsuarioRolesAmbientes: Rol[];
  dataUsuarioRolesAmbientes2: any = [];
  rolSeleccionado: any = [];
  añoSeleccionado: any = [];
  rolActivo: Rol = null;
  ambienteSeleccionado: Ambiente = null;
  idRolAmbiente!: any;

  constructor(
    private fb: FormBuilder,
    private elementosNivelesPermisosService: ElementoNivelPermisoService,
    private alert: AlertService,
    private nivelesService: ComunService,
    private aplicacionesService: AplicacionesService,
    private riesgosService: RiesgosService,
    private indicadoresService: IndicadoresService,
    private ambientesService: AmbienteService,
    private ip: IpPublicService,
    public modal: ModalService,
    private changeDetector: ChangeDetectorRef,
    private store: Store<AppState>,
  ) {
    this.selectItems = [
      { value: ' ', label: 'Seleccione opción' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.elementosIdicadores = [
      { value: 'Atribuciones', label: 'Atribuciones' },
      { value: 'Objetivos', label: 'Objetivos' },
      { value: 'Proyectos', label: 'Proyectos' },
      { value: 'Procesos', label: 'Procesos' },
      { value: 'LineasAccion', label: 'Lineas de Accion' },
    ];
    this.idRolObservador = this.constant.OBSERVADOR;
    this.idRolLinderMetodologico = this.constant.LIDER_METODOLOGICO;
  }

  get permisoForm() {
    return this.formPermiso.controls;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  setForm() {
    this.formPermiso = this.fb.group({
      idSprElementoNivelPermiso: [],
      idSprNivel: [],
      idSprNivelSelect: [],
      idSprELemento: [],
      idSprAplicacion: [],
      idSprElemento: [],
      idSprIndicadRiesgo: [],
      idSprAmbiente: [],
      idSprAmbienteRiesgoIndicador: [],
      comentario: [],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      estado: [' ', [Validators.required]],
    });

    this.formSelectRolAmbiente = this.fb.group({
      idSprRolAmbiente: [this.selectedOption]
    });
  }

  ngOnInit(): void {
    // Obtener datos del almacenamiento de usuario
    this.store.select('usuarioApp').subscribe((response) => {
      if (response.currentUser) {
        this.currentUserRedux = response.currentUser;
        this.idSprUsuario = response.currentUser.idSprUsuario;
        this.currentUser = response.currentUser;
      } else {
        // Manejar el caso en que no se haya establecido currentUser
        // Esto podría ser debido a que el usuario no ha iniciado sesión
        // o que los datos del usuario aún no están disponibles
      }
    });
  
    // Obtener datos del almacenamiento global
    this.store.select('globalApp').subscribe((response) => {
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.rolActivo = response.rolSeleccionado;
      this.rolSeleccionado = response.rolSeleccionado;
  
      if (response.planAniosSeleccionado != null) {
        this.añoSeleccionado = response.planAniosSeleccionado.idSprAnio;
        this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
      }
    });
  
    // Inicializar la aplicación
    this.initApp();
  }
  initApp() {
    this.listDataElementosNivelesPermisos();
    this.setForm();
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  listDataElementosNivelesPermisos() {
    forkJoin([
      this.elementosNivelesPermisosService.list(),
      this.indicadoresService.list(),
      this.aplicacionesService.list(`?filtro=${ConstantsCatalogosIdService.ID_FILTRO_ELEMENTO_PLAN}`),
      this.riesgosService.list(),
      this.nivelesService.list(`?spr_idSprComun= ${ConstantsCatalogosIdService.ID_COMUNES_NIVELES}`),
      this.ambientesService.list(),
    ]).pipe(
      map(([elemntosNivelPermisos, indicadores, aplicaicones, riesgos, niveles, ambientes,]) => {
        this.dataElementosNivelesPermisos = elemntosNivelPermisos;
        this.dataIndicadores = indicadores;
        this.dataAplicaciones = aplicaicones;
        this.dataRiesgos = riesgos;
        this.dataNiveles = niveles;
        this.dataAmbientes = ambientes;

      }
      )
    ).subscribe();
  }

  changeNivel(e: any) {
    this.dataAmbientesNiveles = []
    this.idSprNivelSelected = e.target.value;
    this.getAmbientes(e.target.value);
  }

  getAmbientes(idSprNivelSelectedParaItems: number) {
    this.idSprNivelAmbienteParaItem = idSprNivelSelectedParaItems;
    this.ambientesService.list(`?idSprNivel=${idSprNivelSelectedParaItems}`)
      .subscribe({
        next: (responseAmbientes) => {
          this.dataAmbientesNiveles = responseAmbientes;
        },
      });
  }

  changeSelectedAmbiente(e: any) {
    this.idSprAmbienteSelected = e.target.value.split('*');
    this.dataUsuarioRolesAmbientes2 = {
      ambiente: {
        idSprAmbiente: this.idSprAmbienteSelected[0],
        nivel: {
          idSprNivel: this.idSprAmbienteSelected[3],
          nombre: this.idSprAmbienteSelected[4],
        },
        nombreUnidad: this.idSprAmbienteSelected[1],
        nombreCorto: this.idSprAmbienteSelected[2],
      },
      aplicaciones: this.rolActivo.aplicaciones,
      descripcion: this.rolActivo.descripcion,
      idSprRol: this.rolActivo.idSprRol,
      nombre: this.rolActivo.nombre,
    }
  }

  changeElementos(e: any) {
    this.valueElemento = e.target.value;
  }

  buscarElemento() {
    if(this.añoSeleccionado  != null){
    if (this.idSprAmbienteSelected != 0) {
      this.store.dispatch(globalAccions.ambienteSeleccionado({ ambiente: this.dataUsuarioRolesAmbientes2.ambiente, rol: this.dataUsuarioRolesAmbientes2 }))
    
      // this.store.select('usuarioApp').subscribe((response) => {
      //   this.currentUser = response.currentUser;//JSON.parse(this.buffer);
      //   this.currentUser.idNew = 0;//JSON.parse(this.buffer);
      // });
  
      // localStorage.setItem("currentUser", JSON.stringify(this.currentUser));
      window.location.reload();
    } else {
      this.alert.warning(
        'Atención!',
        'Seleccionar el Nivel y el Ambiente'
      );
    }
    }else {
      this.alert.warning(
        'Atención!',
        'Año NO seleccionado'
      );
    }


  }


  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModalBuscar);
  }

  closeModal() {
    this.modal.closeId(this.nameModalBuscar);
  }

  // Resetear el formulario
  onResetForm() {
    this.formSubmitted = false;
    this.formPermiso.reset();
  }
}
